
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorSeccion } from '@view/a-chat-2/pc/lista/controlador';

    @Component( {
        name: "Componente",
        props: {},
        components: {}
    } )
    export default class Componente extends Vue
    {

        @Prop()
        public Controlador: ControladorSeccion;
        public get Buscador() { return this.Controlador.Buscador; }
        public get Filtros() { return this.Controlador.Buscador.Filtros; }
        public get Estado() { return this.Controlador.Buscador.Estado; }
        public get Items() { return this.Controlador.Buscador.Items; }

        public Abierto: boolean = false;

        Seleccionar( x: number )
        {
            this.Abierto = false;
            if ( this.Filtros.Valores.Cuenta == x )
                return;
            this.Filtros.Valores.Cuenta = x;
            this.Buscador.Buscar( 1 );
        }

        public Refresh: boolean = false;
        Refrescar()
        {
            this.Refresh = false;
            this.$nextTick( () => this.Refresh = true );
        }
    }
